import React from 'react';
import { motion } from 'framer-motion';
import { SectionLabel, SectionHeading } from './ui/UI';
const haveTools = ['Vulnerability scanners', 'Cloud alerts', 'Identity logs', 'Security questionnaires', 'Ticket queues', 'Compliance screenshots', 'Dashboards'];
const stillCant = [{
  label: 'Scanners',
  desc: 'Produce noisy findings without business context.'
}, {
  label: 'Pentests',
  desc: 'Point-in-time. Stale within weeks.'
}, {
  label: 'Enterprise platforms',
  desc: 'Powerful, but expensive and complex.'
}, {
  label: 'AI applications',
  desc: 'Creating new risks faster than teams can validate.'
}];
export function Problem() {
  return <section className="relative w-full py-32 border-t border-white/5" data-id="element-703">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-704">
        <SectionLabel number="02" label="The Problem" className="mb-8" data-id="element-705" />

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12" data-id="element-706">
          {/* Headline */}
          <div className="lg:col-span-12 mb-8" data-id="element-707">
            <SectionHeading size="xl" data-id="element-708">
              Companies have security data.
              <br data-id="element-709" />
              <span className="text-white/40" data-id="element-710">They do not have proof.</span>
            </SectionHeading>
          </div>

          {/* Tools they have */}
          <div className="lg:col-span-5" data-id="element-711">
            <p className="font-mono text-xs uppercase tracking-widest text-white/40 mb-6" data-id="element-712">
              What they already have
            </p>
            <div className="flex flex-wrap gap-2" data-id="element-713">
              {haveTools.map((tool, i) => <motion.span key={i} initial={{
              opacity: 0,
              scale: 0.95
            }} whileInView={{
              opacity: 1,
              scale: 1
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.3,
              delay: i * 0.04
            }} className="px-3 py-1.5 text-sm text-white/60 bg-white/[0.03] border border-white/5 rounded-full" data-id="element-714">
                  {tool}
                </motion.span>)}
            </div>
            <p className="mt-8 text-2xl text-white font-medium leading-snug" data-id="element-715">
              But when the real question comes,
              <br data-id="element-716" />
              they still struggle:
            </p>
            <p className="mt-4 text-3xl md:text-4xl text-[#1a8fd4] font-semibold tracking-tight" data-id="element-717">
              What can actually compromise us?
            </p>
          </div>

          {/* Gaps */}
          <div className="lg:col-span-7 lg:pl-12 lg:border-l border-white/5" data-id="element-718">
            <p className="font-mono text-xs uppercase tracking-widest text-white/40 mb-6" data-id="element-719">
              Where existing tools fall short
            </p>
            <div className="space-y-px bg-white/5" data-id="element-720">
              {stillCant.map((item, i) => <motion.div key={i} initial={{
              opacity: 0,
              x: 10
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.4,
              delay: i * 0.08
            }} className="bg-[#050608] grid grid-cols-12 gap-4 px-6 py-6 hover:bg-white/[0.02] transition-colors" data-id="element-721">
                  <div className="col-span-12 md:col-span-4" data-id="element-722">
                    <span className="text-base font-medium text-white" data-id="element-723">
                      {item.label}
                    </span>
                  </div>
                  <div className="col-span-12 md:col-span-8" data-id="element-724">
                    <span className="text-base text-white/60" data-id="element-725">{item.desc}</span>
                  </div>
                </motion.div>)}
            </div>
            <p className="mt-8 text-lg text-white/70 leading-relaxed" data-id="element-726">
              Periscan is being built for the gap between noisy security data
              and expensive enterprise validation.
            </p>
          </div>
        </div>
      </div>
    </section>;
}